import React from 'react';
import { useNavigate } from 'react-router-dom';
import { saveReturnTo } from '../../utils/returnTo';

interface AuthGateProps {
  action?: string;
  context?: string;
  accent?: string;
}

const AuthGate: React.FC<AuthGateProps> = ({
  action = 'continue',
  context,
  accent = '#c8a06a',
}) => {
  const navigate = useNavigate();

  const goAuth = (path: '/login' | '/register') => {
    saveReturnTo(window.location.pathname + window.location.search);
    navigate(path);
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      padding: '36px 28px',
      borderRadius: 16,
      background: 'rgba(255,255,255,0.025)',
      border: '1px solid rgba(255,255,255,0.08)',
      gap: 16,
    }}>
      <div style={{
        width: 52, height: 52,
        borderRadius: '50%',
        background: `${accent}18`,
        border: `1.5px solid ${accent}44`,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: '1.4rem',
      }}>
        🔐
      </div>

      <div>
        <p style={{ color: '#f1f5f9', fontWeight: 800, fontSize: '1rem', margin: 0, lineHeight: 1.3 }}>
          Sign in to {action}
        </p>
        <p style={{ color: '#64748b', fontSize: '0.8rem', marginTop: 8, lineHeight: 1.6, maxWidth: 280, margin: '8px auto 0' }}>
          {context ?? 'Create a free account to place orders and track your history.'}
        </p>
      </div>

      <div style={{ display: 'flex', gap: 10, width: '100%', maxWidth: 300, marginTop: 4 }}>
        <button
          type="button"
          onClick={() => goAuth('/login')}
          style={{
            flex: 1, padding: '11px 0', borderRadius: 10,
            border: `1.5px solid ${accent}`,
            background: 'transparent', color: accent,
            fontWeight: 700, fontSize: '0.85rem', cursor: 'pointer',
            transition: 'background 0.15s, color 0.15s',
          }}
          onMouseEnter={(e) => { (e.currentTarget as HTMLButtonElement).style.background = `${accent}18`; }}
          onMouseLeave={(e) => { (e.currentTarget as HTMLButtonElement).style.background = 'transparent'; }}
        >
          Log in
        </button>
        <button
          type="button"
          onClick={() => goAuth('/register')}
          style={{
            flex: 1, padding: '11px 0', borderRadius: 10,
            border: 'none',
            background: accent, color: '#000',
            fontWeight: 800, fontSize: '0.85rem', cursor: 'pointer',
            transition: 'opacity 0.15s',
          }}
          onMouseEnter={(e) => { (e.currentTarget as HTMLButtonElement).style.opacity = '0.88'; }}
          onMouseLeave={(e) => { (e.currentTarget as HTMLButtonElement).style.opacity = '1'; }}
        >
          Create account
        </button>
      </div>
    </div>
  );
};

export default AuthGate;
